import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["firstName", "icon", "indicatorBadge", "indicatorBadgeDotIntent", "indicatorBadgeIcon", "indicatorBadgeIconIntent", "indicatorBadgeImageAltText", "indicatorBadgeImageSrc", "indicatorBadgeType", "lastName", "size", "src", "type"];
import React from 'react';
import { IndicatorBadge } from '../IndicatorBadge';
import MuiAvatar from '@mui/material/Avatar';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function Avatar(props) {
  var _props$firstName = props.firstName,
    firstName = _props$firstName === void 0 ? '' : _props$firstName,
    icon = props.icon,
    _props$indicatorBadge = props.indicatorBadge,
    indicatorBadge = _props$indicatorBadge === void 0 ? false : _props$indicatorBadge,
    _props$indicatorBadge2 = props.indicatorBadgeDotIntent,
    indicatorBadgeDotIntent = _props$indicatorBadge2 === void 0 ? 'success' : _props$indicatorBadge2,
    _props$indicatorBadge3 = props.indicatorBadgeIcon,
    indicatorBadgeIcon = _props$indicatorBadge3 === void 0 ? 'Plus' : _props$indicatorBadge3,
    _props$indicatorBadge4 = props.indicatorBadgeIconIntent,
    indicatorBadgeIconIntent = _props$indicatorBadge4 === void 0 ? 'primary' : _props$indicatorBadge4,
    indicatorBadgeImageAltText = props.indicatorBadgeImageAltText,
    indicatorBadgeImageSrc = props.indicatorBadgeImageSrc,
    _props$indicatorBadge5 = props.indicatorBadgeType,
    indicatorBadgeType = _props$indicatorBadge5 === void 0 ? 'dot' : _props$indicatorBadge5,
    _props$lastName = props.lastName,
    lastName = _props$lastName === void 0 ? '' : _props$lastName,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    src = props.src,
    _props$type = props.type,
    type = _props$type === void 0 ? 'Image' : _props$type,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: indicatorBadge ? /*#__PURE__*/_jsx(IndicatorBadge, {
      Icon: indicatorBadgeIcon,
      dotIntent: indicatorBadgeDotIntent,
      iconIntent: indicatorBadgeIconIntent,
      imageAltText: indicatorBadgeImageAltText,
      imageSrc: indicatorBadgeImageSrc,
      size: size,
      type: indicatorBadgeType,
      children: /*#__PURE__*/_jsxs(MuiAvatar, _extends({
        sizes: size,
        src: src
      }, others, {
        tabIndex: 0,
        children: [type === 'Icon' && icon, type === 'Monogram' && firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()]
      }))
    }) : /*#__PURE__*/_jsxs(MuiAvatar, _extends({
      sizes: size,
      src: src
    }, others, {
      tabIndex: 0,
      children: [type === 'Icon' && icon, type === 'Monogram' && firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()]
    }))
  });
}